import { render, staticRenderFns } from "./settings-requests.modal.vue?vue&type=template&id=69777172&"
import script from "./settings-requests.modal.vue?vue&type=script&lang=js&"
export * from "./settings-requests.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports